import { render, staticRenderFns } from "./PlansStep.vue?vue&type=template&id=7258f99f&lang=pug"
import script from "./PlansStep.vue?vue&type=script&lang=js"
export * from "./PlansStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormPlans: require('/home/docker/code/frontend/components/form/Plans.vue').default})
